;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
	locales: ["nl", "en", "fr"],

	defaultLocale: "nl",

	// pathnames: {
	// 	"/insights/[...slug]": {
	// 		nl: "/inzichten/[...slug]",
	// 		en: "/insights/[...slug]",
	// 		fr: "/aperçus/[...slug]",
	// 	},
	// },
});

export type Locale = (typeof routing.locales)[number];

export const visibleLocales: Locale[] = ["nl", "en", "fr"];

export const { Link, redirect, usePathname, useRouter, getPathname } =
	createNavigation(routing);
